import React from 'react'
import AppointmentWindows from './AppointmentWindows'

const SchedulerPanel = ({
    pickupOrDelivery,
    consolidatedOpenTimeWindows,
    existingPickupAppts,
    existingDeliveryAppts,
    shipment,
    reload
}) => {
    if (!pickupOrDelivery) return null

    const windows = pickupOrDelivery === 'Pickup'
        ? consolidatedOpenTimeWindows?.pickup
        : consolidatedOpenTimeWindows?.delivery

    const existingAppts = pickupOrDelivery === 'Pickup'
        ? existingPickupAppts
        : existingDeliveryAppts

    return (
        <div className="p-2 p-md-3">
            <h4 className="mt-2 mt-md-3 px-1">
                Schedule {pickupOrDelivery} Appointment
            </h4>
            <div style={{ overflowX: 'auto' }}>
                <AppointmentWindows
                    type={pickupOrDelivery}
                    consolidatedWindows={windows}
                    existingAppts={existingAppts}
                    shipment={shipment}
                    reload={reload}
                />
            </div>
        </div>
    )
}

export default SchedulerPanel
